/* eslint-disable @typescript-eslint/no-explicit-any */
import { Component, forwardRef, OnInit, Injector, input, signal, computed } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR, NgControl, FormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { CustomErrorDisplayComponent } from '../custom-error-display/custom-error-display.component';

@Component({
  selector: 'lib-custom-switch',
  standalone: true,
  imports: [CommonModule, FormsModule, CustomErrorDisplayComponent],
  templateUrl: './custom-switch.component.html',
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => CustomSwitchComponent),
      multi: true,
    },
  ],
})
export class CustomSwitchComponent implements ControlValueAccessor, OnInit {
  label = input<string>('');
  description = input<string>('');
  name = input<string>('');
  errors = input<{ [key: string]: string }>({});
  displayError = input<boolean>(true);

  readonly effectiveName = computed(() => {
    const currentName = this.name();
    if (currentName) return currentName;
    const currentLabel = this.label();
    if (currentLabel) {
      return (
        currentLabel.toLowerCase().replace(/\s+/g, '-') +
        `-${Math.random().toString(36).substring(2, 7)}`
      );
    }
    return `custom-switch-${Math.random().toString(36).substring(2, 9)}`;
  });

  _value = signal<boolean>(false);
  isDisabled = false;
  ngControl: NgControl | null = null;

  onChange: (value: boolean) => void = () => {};
  onTouched: () => void = () => {};

  constructor(private _injector: Injector) {}

  ngOnInit(): void {
    this.ngControl = this._injector.get(NgControl, null);
    if (this.ngControl) {
      this.ngControl.valueAccessor = this;
    }
  }

  get value(): boolean {
    return this._value();
  }

  set value(val: boolean) {
    if (val !== this._value()) {
      this._value.set(val);
      this.onChange(val);
    }
  }

  writeValue(value: any): void {
    this._value.set(!!value);
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  setDisabledState?(isDisabled: boolean): void {
    this.isDisabled = isDisabled;
  }

  toggle(): void {
    if (!this.isDisabled) {
      this.value = !this.value;
      this.onTouched();
    }
  }
}
